module.exports = __webpack_public_path__ + "img/user.e2915d65.svg";